<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-primary">
              <i class="nc-icon nc-circle-09 text-primary"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Pelanggan</p>
              <h4 class="card-title"><b>
                <b-spinner v-if="loadDataUserTotal" type="border" small label="Small Spinner" class="text-primary"></b-spinner>
                  {{stock.totaluser.total}}
              </b></h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Update Terakhir
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-success">
              <i class="nc-icon nc-circle-09 text-success"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Pelanggan Aktif</p>
              <h4 class="card-title"><b>
                <b-spinner v-if="loadDataActive" type="border" small label="Small Spinner" class="text-success"></b-spinner>
                {{stock.invoiceactive.total}}
              </b></h4>
            </div>
            <div slot="footer">
              <i class="fa fa-calendar-o"></i>1 hari yang lalu
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-danger">
              <i class="nc-icon nc-circle-09 text-danger"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Pelanggan Tidak Aktif</p>
              <h4 class="card-title">
                <b-spinner v-if="loadDataInactive" type="border" small label="Small Spinner" class="text-danger"></b-spinner>
                <b>{{stock.invoiceinactive.total}}</b>
              </h4>
            </div>
            <div slot="footer">
              <i class="fa fa-clock-o"></i>1 hari yang lalu
            </div>
          </stats-card>
        </div>

        <div class="col-xl-3 col-md-6">
          <stats-card>
            <div slot="header" class="icon-info">
              <i class="nc-icon nc-grid-45 text-info"></i>
            </div>
            <div slot="content">
              <p class="card-category">Total Perangkat</p>
              <h4 class="card-title">
                <b-spinner v-if="loadDataSetup" type="border" small label="Small Spinner" class="text-info"></b-spinner>
                <b>{{stock.setup.total}}</b>
              </h4>
            </div>
            <div slot="footer">
              <i class="fa fa-refresh"></i>Update Terakhir
            </div>
          </stats-card>
        </div>

      </div>
      <div class="row">
        <!-- <div class="col-md-8">
          <chart-card :chart-data="lineChart.data"
                      :chart-options="lineChart.options"
                      :responsive-options="lineChart.responsiveOptions">
            <template slot="header">
              <h4 class="card-title">Users Behavior</h4>
              <p class="card-category">24 Hours performance</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Open
                <i class="fa fa-circle text-danger"></i> Click
                <i class="fa fa-circle text-warning"></i> Click Second Time
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </template>
          </chart-card>
        </div> -->

        <div class="col-md-8">
          <chart-card
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">Grafik Status Pelanggan</h4>
              <p class="card-category">Update Terakhir</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-success"></i> Aktif
                <i class="fa fa-circle text-danger"></i> Tidak Aktif
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> 1 hari yang lalu
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-4">
          <chart-card :chart-data="pieChart.data" chart-type="Pie">
            <template slot="header">
              <h4 class="card-title">Presentase Status Pelanggan</h4>
              <p class="card-category">Update Terakhir</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-success"></i> Aktif
                <i class="fa fa-circle text-danger"></i> Tidak Aktif
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-clock-o"></i> 1 hari yang lalu
              </div>
            </template>
          </chart-card>
        </div>
      </div>

      <!-- <div class="row">
        <div class="col-md-6">
          <chart-card
            :chart-data="barChart.data"
            :chart-options="barChart.options"
            :chart-responsive-options="barChart.responsiveOptions"
            chart-type="Bar">
            <template slot="header">
              <h4 class="card-title">2014 Sales</h4>
              <p class="card-category">All products including Taxes</p>
            </template>
            <template slot="footer">
              <div class="legend">
                <i class="fa fa-circle text-info"></i> Tesla Model S
                <i class="fa fa-circle text-danger"></i> BMW 5 Series
              </div>
              <hr>
              <div class="stats">
                <i class="fa fa-check"></i> Data information certified
              </div>
            </template>
          </chart-card>
        </div>

        <div class="col-md-6">
          <card>
            <template slot="header">
              <h5 class="title">Tasks</h5>
              <p class="category">Backend development</p>
            </template>
            <l-table :data="tableData.data"
                     :columns="tableData.columns">
              <template slot="columns"></template>

              <template slot-scope="{row}">
                <td>
                  <base-checkbox v-model="row.checked"></base-checkbox>
                </td>
                <td>{{row.title}}</td>
                <td class="td-actions text-right">
                  <button type="button" class="btn-simple btn btn-xs btn-info" v-tooltip.top-center="editTooltip">
                    <i class="fa fa-edit"></i>
                  </button>
                  <button type="button" class="btn-simple btn btn-xs btn-danger" v-tooltip.top-center="deleteTooltip">
                    <i class="fa fa-times"></i>
                  </button>
                </td>
              </template>
            </l-table>
            <div class="footer">
              <hr>
              <div class="stats">
                <i class="fa fa-history"></i> Updated 3 minutes ago
              </div>
            </div>
          </card>

        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
  import * as axios from 'axios'
  import moment from 'moment'
  import ChartCard from 'src/components/Cards/ChartCard.vue'
  import StatsCard from 'src/components/Cards/StatsCard.vue'
  import LTable from 'src/components/Table.vue'

  export default {
    components: {
      LTable,
      ChartCard,
      StatsCard
    },
    created(){     
      if(!localStorage.getItem('accessToken')){
        this.$router.push('/login')
      }else{
        this.getTotalUser()
        this.getInvoiceLainActive()
        this.getInvoiceLainInactive()
        this.getStockSetup()
      }
    },
    data () {
      return {
        editTooltip: 'Edit Task',
        deleteTooltip: 'Remove',
        pieChart: {
          data: {
            labels: ['90%', '10%'],
            series: [90, 10]
          }
        },
        lineChart: {
          data: {
            labels: ['9:00AM', '12:00AM', '3:00PM', '6:00PM', '9:00PM', '12:00PM', '3:00AM', '6:00AM'],
            series: [
              [287, 385, 490, 492, 554, 586, 698, 695],
              [67, 152, 143, 240, 287, 335, 435, 437],
              [23, 113, 67, 108, 190, 239, 307, 308]
            ]
          },
          options: {
            low: 0,
            high: 800,
            showArea: false,
            height: '245px',
            axisX: {
              showGrid: false
            },
            lineSmooth: true,
            showLine: true,
            showPoint: true,
            fullWidth: true,
            chartPadding: {
              right: 50
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        barChart: {
          data: {
            labels: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            series: [
              [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
              [112, 143, 180, 180, 153, 153, 100, 164, 168, 110, 136, 195]
            ]
          },
          options: {
            seriesBarDistance: 10,
            axisX: {
              showGrid: false
            },
            height: '245px'
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        tableData: {
          data: [
            {title: 'Sign contract for "What are conference organizers afraid of?"', checked: false},
            {title: 'Lines From Great Russian Literature? Or E-mails From My Boss?', checked: true},
            {
              title: 'Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit',
              checked: true
            },
            {title: 'Create 4 Invisible User Experiences you Never Knew About', checked: false},
            {title: 'Read "Following makes Medium better"', checked: false},
            {title: 'Unfollow 5 enemies from twitter', checked: false}
          ]
        },
        loadDataUserTotal:true,
        loadDataActive:true,
        loadDataInactive:true,
        loadDataSetup:true,
        stock:{
          setup:[],
          invoiceactive:[],
          invoiceinactive:[],
          totaluser:[]
        },
      }
    },
    methods: {
      getTotalUser(url=(this.$baseUrl+'/api/stock/total-user')){//Total Pelanggan
        this.loadDataUserTotal=true
        axios.post(url,{},{
            'headers':{
              'Authorization':'Bearer '+localStorage.getItem('accessToken')
            }
          }
        ).then((result)=>{
          console.log(result)
           this.stock.totaluser = result.data;
          this.loadDataUserTotal=false
        }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
          console.log(err)
          this.loadDataUserTotal=false
        })
      },
      getInvoiceLainActive(url=(this.$baseUrl+'/api/stock/invoice-lain-active')){//Total Pelanggan Aktif
        this.loadDataActive=true
        axios.post(url,{},{
            'headers':{
              'Authorization':'Bearer '+localStorage.getItem('accessToken')
            }
          }
        ).then((result)=>{
          console.log(result)
           this.stock.invoiceactive = result.data;
          this.loadDataActive=false
        }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
          console.log(err)
          this.loadDataActive=false
        })
      },
      getInvoiceLainInactive(url=(this.$baseUrl+'/api/stock/invoice-lain-inactive')){//Total Pelanggan Tidak Aktif
        this.loadDataInactive=true
        axios.post(url,{},{
            'headers':{
              'Authorization':'Bearer '+localStorage.getItem('accessToken')
            }
          }
        ).then((result)=>{
          console.log(result)
           this.stock.invoiceinactive = result.data;
          this.loadDataInactive=false
        }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
          console.log(err)
          this.loadDataInactive=false
        })
      },
      getStockSetup(url=(this.$baseUrl+'/api/stock/setup')){//Total Perangkat
        this.loadDataSetup=true
        axios.post(url,{},{
            'headers':{
              'Authorization':'Bearer '+localStorage.getItem('accessToken')
            }
          }
        ).then((result)=>{
          console.log(result)
           this.stock.setup = result.data;
          this.loadDataSetup=false
        }).catch((err)=>{
          //check if token fail
          if(err.response && err.response.status==401){
            localStorage.removeItem('accessToken')
          this.$router.push('/login')
          }
          console.log(err)
          this.loadDataSetup=false
        })
      },
    }
  }
</script>
<style>
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
      fill: #28a745;
  }
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
    fill: #dc3545;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
    stroke: #28a745;
}
.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
    stroke: #dc3545;
}
</style>
